import { createStore, combineReducers, applyMiddleware } from 'redux';
import { ProjectReducer } from '../Reducer/Reducer';
import thunk from 'redux-thunk';
import { AuthReducer } from '../Reducer/AuthReducer';
import flowReducer from '../Flow/redux/FlowReducer';
import dataSourcesReducer from '../Flow/redux/dataSourcesSlice';

const Store = createStore(
  combineReducers({
    project_reducer: ProjectReducer,
    auth_reducer: AuthReducer,
    flow: flowReducer,
    dataSources: dataSourcesReducer,
  }),
  applyMiddleware(thunk)
);
export default Store;
